<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="27.649" height="30.5" viewBox="0 0 27.649 30.5">
        <path
            id="Tracé_189"
            data-name="Tracé 189"
            d="M910.7,418.67v1.594a2.313,2.313,0,1,1-4.626,0V418.62h-9.854v1.644a2.313,2.313,0,1,1-4.625,0V418.67a4.713,4.713,0,0,0-4.022,4.656v17.737a4.712,4.712,0,0,0,4.706,4.706H910.02a4.712,4.712,0,0,0,4.706-4.706V423.326A4.713,4.713,0,0,0,910.7,418.67Zm1.488,22.393a2.179,2.179,0,0,1-2.172,2.172H892.283a2.179,2.179,0,0,1-2.172-2.172v-14.3h22.081Zm-18.28-19.35a1.433,1.433,0,0,1-1.408-1.449v-3.048a1.408,1.408,0,1,1,2.815,0v3.048A1.433,1.433,0,0,1,893.912,421.713Zm14.479,0a1.433,1.433,0,0,1-1.408-1.449v-3.048a1.409,1.409,0,1,1,2.816,0v3.048A1.433,1.433,0,0,1,908.391,421.713Zm-13.154,10.04h-3.823v-3.822h3.823Zm5.217-3.823h-3.823v3.822h3.823Zm5.217,0h-3.823v3.822h3.823Zm5.217,0h-3.822v3.822h3.822ZM895.237,433h-3.823v3.823h3.823Zm5.217,0h-3.823v3.823h3.823Zm5.217,0h-3.823v3.823h3.823Zm5.217,0h-3.822v3.823h3.822Zm-15.651,5.068h-3.823v3.823h3.823Zm5.217,0h-3.823v3.823h3.823Zm5.217,0h-3.823v3.823h3.823Z"
            transform="translate(-887.327 -415.519)"
            fill="none"
            stroke="#5f5f60"
            stroke-miterlimit="10"
            stroke-width="0.5"
        />
    </svg>
</template>
<script>
export default {
    props: {
        color: {
            type: String,
            required: true
        }
    }
};
</script>



// WEBPACK FOOTER //
// CalendarIcon.vue?1b186b2a